const getRouteWithParams = (route: string, params: IUrlParams) => {
  if (Object.keys(params).length === 0) {
    return `${route}`;
  }

  const tmp = Object.keys(params).map(key => `${key}=${params[key]}`);
  const separator = route.indexOf('?') > 0 ? '&' : '?';
  const url = route.endsWith(separator) ? route : `${route}${separator}`;
  return `${url}${tmp.join('&')}`;
};

export default getRouteWithParams;
